/**
 * 提供基础API
 * 【注意】：接口写法均为异步写法，但实际执行是分为真异步以及假异步。
 * 其中涉及网络请求的接口，均为真异步，并且callback写在args内。
 * 接口名称前缀为async，均为真异步
 * 其余为假异步，即同步执行
 */
define(['apiUtil', 'observer', 'baseApi'], function(apiUtil, observer, baseApi) {
  const CHANNEL_USER_STATE_CHANGED = 'CHANNEL_USER_STATE_CHANGED';
  const { executeApi, asyncExecuteApi } = apiUtil;

  baseApi.setWindowCallBack('userStateChanged', (res) => {
    observer(CHANNEL_USER_STATE_CHANGED).publish(res.result.logined, res.result.sid);
  });

  return {
    CHANNEL_USER_STATE_CHANGED,

    login() {
      executeApi('login');
    },

    checkUserLogin() {
      executeApi('checkUserLogin'); // 检查后会触发 userStateChanged 通知
    },
  };
});



/** WEBPACK FOOTER **
 ** ./src/scripts/apiv2/userApi.js
 **/